import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const sections = [
  {
    title: 'Buyer Obligations in Bangladesh',
    icon: 'User',
    color: '#00B450',
    items: [
      'Register property deed at Sub-Registrar office within 4 months of agreement',
      'Pay stamp duty (typically 1.5% of deed value) and registration fee (1%)',
      'Obtain mutation (namjari) certificate from Union Parishad or City Corporation',
      'Verify land classification (khatian) — ensure it is not khas (government) land',
      'Confirm no encumbrance or mortgage on the property via bank certificate',
      'Ensure RAJUK building plan approval before purchasing any apartment or plot'
    ]
  },
  {
    title: 'RAJUK Buyer Protections',
    icon: 'Shield',
    color: '#22c55e',
    items: [
      'RAJUK can halt unauthorized construction and penalize non-compliant developers',
      'Buyers can file complaints with RAJUK for plan deviations after purchase',
      'Real Estate Development and Management Act 2010 protects flat buyers',
      'Developers must provide registered deed for each flat sold',
      'Land use clearance mandatory — verify before signing any agreement',
      'RAJUK Detailed Area Plan (DAP) governs all Dhaka development approvals'
    ]
  },
  {
    title: 'Dispute Resolution in Bangladesh',
    icon: 'Scale',
    color: '#f59e0b',
    items: [
      'File complaint with RAJUK Enforcement Division for building violations',
      'Civil Court for property ownership and title deed disputes',
      'Bangladesh Real Estate Association (REHAB) for developer disputes',
      'District Court for land boundary and mutation disputes',
      'National Board of Revenue for stamp duty and tax disputes',
      'High Court Division for constitutional property rights issues'
    ]
  }
];

const BangladeshLegalGuide = () => {
  const [open, setOpen] = useState(0);

  return (
    <div className="rounded-2xl p-6" style={{ background: 'rgba(10,22,40,0.9)', border: '1px solid rgba(0,180,80,0.2)' }}>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'rgba(0,180,80,0.1)', border: '1px solid rgba(0,180,80,0.3)' }}>
          <Icon name="BookOpen" size={20} color="#00B450" />
        </div>
        <div>
          <h3 className="text-lg font-bold" style={{ color: '#E8F4FF' }}>Legal Requirements & Protections</h3>
          <p className="text-xs" style={{ color: '#6B9EC4' }}>Bangladesh property law obligations, RAJUK protections, and dispute resolution</p>
        </div>
      </div>
      <div className="space-y-3">
        {sections?.map((sec, i) => (
          <div key={i} className="rounded-xl overflow-hidden" style={{ border: '1px solid rgba(0,180,80,0.15)' }}>
            <button
              onClick={() => setOpen(open === i ? -1 : i)}
              className="w-full flex items-center justify-between p-4"
              style={{ background: open === i ? 'rgba(0,180,80,0.08)' : 'rgba(0,180,80,0.03)' }}
            >
              <div className="flex items-center gap-3">
                <Icon name={sec?.icon} size={18} color={sec?.color} />
                <span className="font-semibold text-sm" style={{ color: '#E8F4FF' }}>{sec?.title}</span>
              </div>
              <Icon name={open === i ? 'ChevronUp' : 'ChevronDown'} size={16} color="#6B9EC4" />
            </button>
            {open === i && (
              <div className="px-4 pb-4">
                <ul className="space-y-2">
                  {sec?.items?.map((item, j) => (
                    <li key={j} className="flex items-start gap-2 text-sm" style={{ color: '#6B9EC4' }}>
                      <span className="mt-0.5 flex-shrink-0" style={{ color: sec?.color }}>•</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
        <button
          onClick={() => window.open('http://www.rajuk.gov.bd', '_blank', 'noopener,noreferrer')}
          className="flex items-center justify-center gap-2 py-3 px-4 rounded-xl font-medium text-sm transition-all"
          style={{ background: '#00B450', color: '#FFFFFF' }}
        >
          <Icon name="AlertCircle" size={16} color="#FFFFFF" />
          File RAJUK Complaint
        </button>
        <button
          onClick={() => window.open('http://www.rehab-bd.org', '_blank', 'noopener,noreferrer')}
          className="flex items-center justify-center gap-2 py-3 px-4 rounded-xl font-medium text-sm transition-all"
          style={{ background: 'rgba(0,180,80,0.1)', border: '1px solid rgba(0,180,80,0.3)', color: '#00B450' }}
        >
          <Icon name="Download" size={16} color="#00B450" />
          REHAB Buyer Guide
        </button>
      </div>
    </div>
  );
};

export default BangladeshLegalGuide;
